import React from 'react'

import Icon, { Icons } from 'components/icons'

const IconButton = props => {
  if (!props.name || !Icons[props.name]) {
    return null
  }

  const { name, onClick, size, color, ariaLabel } = props
  return (
    <button onClick={onClick} aria-label={ariaLabel}>
      <Icon name={name} size={size} color={color} />
    </button>
  )
}

export default IconButton
